export default "<div class=\"sc-modal\">\n  <ng-content></ng-content>\n</div>\n<div class=\"sc-modal__overlay\" (click)=\"onOverlayClick()\"></div>\n"